// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { supabase } from './lib/supabaseClient';

// Loading component
const LoadingScreen = () => (
  <div className="min-h-screen bg-[#FDF8F0] flex items-center justify-center">
    <div className="text-center">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-[#8B2635] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-[#FDF8F0] rounded-full"></div>
        </div>
      </div>
      <p className="text-[#6B6B6B] font-medium">Loading application...</p>
      <p className="text-sm text-[#8B2635] mt-2">Please wait</p>
    </div>
  </div>
);

// Simple 404 component
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDF8F0]">
    <div className="text-center max-w-md px-4">
      <h1 className="text-6xl font-bold text-[#8B2635] mb-4">404</h1>
      <p className="text-xl text-[#6B6B6B] mb-6">Page not found</p>
      <p className="text-sm text-[#6B6B6B] mb-8">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a 
        href="/" 
        className="inline-flex items-center px-6 py-3 bg-[#8B2635] text-white rounded-lg hover:bg-[#B23B4A] transition-colors"
      >
        Return to Home
      </a>
    </div>
  </div>
);

function App() {
  const [initializing, setInitializing] = useState(true);
  const [initialAuthChecked, setInitialAuthChecked] = useState(false);

  useEffect(() => {
    // Check auth state on app start
    const checkInitialAuth = async () => {
      try {
        
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
        } else {
        }
        
      } catch (error) {
      } finally {
        setInitializing(false);
        setInitialAuthChecked(true);
      }
    };

    checkInitialAuth();

    // Set up auth state change listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      
      if (event === 'SIGNED_IN') {
      } else if (event === 'SIGNED_OUT') {
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  if (initializing) {
    return <LoadingScreen />;
  }

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Navigate to="/admin-login" replace />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;